import { IonButtons, IonContent, IonList, IonMenuButton, IonPage } from "@ionic/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { Button } from "../../../components/button/button";
import { Footer } from "../../../components/footer/footer";
import Header from "../../../components/header/header";
import RefreshComponent from "../../../components/refresh/refreshComponent";
import { ReturnLogin } from "../../../components/returnLoginComponent/returncomponentLogin";
import { AppRoutes } from "../../../constants/appRoutes";
import { fetchRequestList } from "../../../redux/actions/request/request";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { RequestListContainerStyle } from "./containerStyle.jss";
import RequestListItem from "./item/item";

const RequestListContainer: React.FC = () => {
    const { t } = useTranslation("common");
    const theme = useTheme();
    const style = RequestListContainerStyle({ theme });
    const dispatch = useAppDispatch();
    const { list, loading } = useAppSelector((state) => state.requestList);
    const { isClaimsLoaded } = useAppSelector((state) => state.userClaims);

    useEffect(() => {
        if (isClaimsLoaded && list === undefined && !loading) {
            dispatch(fetchRequestList());
        }
    }, [loading, list, isClaimsLoaded]);

    return (
        <IonPage>
            <Header
                element={
                    <IonButtons slot="start">
                        <IonMenuButton></IonMenuButton>
                    </IonButtons>
                }
                showLogout={true}
                title={t("ROUTES_TITLE.REQUEST")}
            />
            <IonContent
                fullscreen={true}
                className="ion-padding"
            >
                <RefreshComponent
                    onRefreshComponent={() => {
                        dispatch(fetchRequestList());
                    }}
                />

                <span className={style.headerHistory}>{t("PAGE.REQUEST.HISTORY")}</span>
                <IonList className={style.list}>
                    {list &&
                        list.length > 0 &&
                        list.map((item) => {
                            return (
                                <RequestListItem
                                    key={item.id}
                                    request={item}
                                />
                            );
                        })}
                </IonList>
            </IonContent>

            <Footer
                element={
                    <Button
                        slot="center"
                        color={"secondary"}
                        title={t("PAGE.REQUEST.CREATE")}
                        link={AppRoutes.ADD_REQUEST}
                        direction="forward"
                    />
                }
            />
            <ReturnLogin></ReturnLogin>
        </IonPage>
    );
};

export default RequestListContainer;
